import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantTransactionAuthorizer = {
  namespaced: true,

  state: () => ({
    selectedMerchant: null,
    // ------------------------------------------
    localAuthorizers: [],
    selectedAuthorizer: null,
    newTransactionAuthorizerButtonClicked: false,
    // ------------------------------------------
    authorizationFlows: [],
    authorizationLevels: [],
    authorizerGroups: [],
    authorizerGroupsOfUser: [],
    // ------------------------------------------
    usersForFundDisbursementAuthorizers: [],
    transactionAuthorizers: [],
    transactionAuthorizersPendingByGroup: {
      data: [],
      totalRecords: 0
    },
    transactionAuthorizersDisapprovedByGroup: {
      data: [],
      totalRecords: 0
    },
    transactionAuthorizersAwaitingDeleteByGroup: {
      data: [],
      totalRecords: 0
    },
    transactionAuthorizersDeletedByGroup: {
      data: [],
      totalRecords: 0
    },
    // ------------------------------------------
    transactionAuthorizersPending: {
      data: [],
      totalRecords: 0
    },
    transactionAuthorizersApproved: {
      data: [],
      totalRecords: 0
    },
    transactionAuthorizersDisapproved: {
      data: [],
      totalRecords: 0
    },
    transactionAuthorizersDeleted: {
      data: [],
      totalRecords: 0
    },
    transactionAuthorizersAwaitingDeletionApproval: {
      data: [],
      totalRecords: 0
    },
    // ------------------------------------------
    fundDisbursementAuthorizers: {
      data: [],
      isLastAuthorizer: null
    }
  }),

  getters: {
    _selectedMerchant: state => state.selectedMerchant,
    // ------------------------------------------
    _localAuthorizers: state => state.localAuthorizers,
    _selectedAuthorizer: state => state.selectedAuthorizer,
    _newTransactionAuthorizerButtonClicked: state => state.newTransactionAuthorizerButtonClicked,
    // ------------------------------------------
    _authorizationFlows: state => state.authorizationFlows,
    _authorizationLevels: state => state.authorizationLevels,
    _authorizerGroups: state => state.authorizerGroups,
    _authorizerGroupsOfUser: state => state.authorizerGroupsOfUser,
    // ------------------------------------------
    _usersForFundDisbursementAuthorizers: state => state.usersForFundDisbursementAuthorizers,
    _transactionAuthorizers: state => state.transactionAuthorizers,
    _transactionAuthorizersPendingByGroup: state => state.transactionAuthorizersPendingByGroup,
    _transactionAuthorizersDisapprovedByGroup: state => state.transactionAuthorizersDisapprovedByGroup,
    _transactionAuthorizersAwaitingDeleteByGroup: state => state.transactionAuthorizersAwaitingDeleteByGroup,
    _transactionAuthorizersDeletedByGroup: state => state.transactionAuthorizersDeletedByGroup,
    // ------------------------------------------
    _transactionAuthorizersPending: state => state.transactionAuthorizersPending,
    _transactionAuthorizersApproved: state => state.transactionAuthorizersApproved,
    _transactionAuthorizersDisapproved: state => state.transactionAuthorizersDisapproved,
    _transactionAuthorizersDeleted: state => state.transactionAuthorizersDeleted,
    _transactionAuthorizersAwaitingDeletionApproval: state => state.transactionAuthorizersAwaitingDeletionApproval,
    // ------------------------------------------
    _fundDisbursementAuthorizers: state => state.fundDisbursementAuthorizers
  },

  mutations: {
    SELECTED_MERCHANT (state, data) {
      state.selectedMerchant = data
    },
    // ---------------------------------------------------
    LOCAL_AUTHORIZERS (state, data) {
      state.localAuthorizers = [...state.localAuthorizers, data]
    },
    CLEAR_LOCAL_AUTHORIZERS (state) {
      state.localAuthorizers = []
    },
    SELECTED_AUTHORIZER (state, data) {
      state.selectedAuthorizer = data
    },
    NEW_TRANSACTION_AUTHORIZER_BUTTON_CLICKED (state, data) {
      state.newTransactionAuthorizerButtonClicked = data
    },
    // ---------------------------------------------------
    AUTHORIZATION_FLOWS (state, data) {
      state.authorizationFlows = data
    },
    AUTHORIZATION_LEVELS  (state, data) {
      state.authorizationLevels = data
    },
    AUTHORIZER_GROUPS (state, data) {
      state.authorizerGroups = data
    },
    AUTHORIZER_GROUPS_OF_USER (state, data) {
      state.authorizerGroupsOfUser = data
    },
    // ---------------------------------------------------
    USERS_FOR_FUND_DISBURSEMENT_AUTHORIZERS (state, data) {
      state.usersForFundDisbursementAuthorizers = data
    },
    TRANSACTION_AUTHORIZERS (state, data) {
      state.transactionAuthorizers = data
    },
    TRANSACTION_AUTHORIZERS_PENDING_BY_GROUP (state, { totalRecords, data }) {
      state.transactionAuthorizersPendingByGroup.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersPendingByGroup.data = data
    },
    TRANSACTION_AUTHORIZERS_DISAPPROVED_BY_GROUP (state, { totalRecords, data }) {
      state.transactionAuthorizersDisapprovedByGroup.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersDisapprovedByGroup.data = data
    },
    TRANSACTION_AUTHORIZERS_AWAITING_DELETE_BY_GROUP (state, { totalRecords, data }) {
      state.transactionAuthorizersAwaitingDeleteByGroup.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersAwaitingDeleteByGroup.data = data
    },
    TRANSACTION_AUTHORIZERS_DELETED_BY_GROUP (state, { totalRecords, data }) {
      state.transactionAuthorizersDeletedByGroup.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersDeletedByGroup.data = data
    },
    // ---------------------------------------------------
    TRANSACTION_AUTHORIZERS_PENDING (state, { totalRecords, data }) {
      state.transactionAuthorizersPending.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersPending.data = data
    },
    TRANSACTION_AUTHORIZERS_APPROVED (state, { totalRecords, data }) {
      state.transactionAuthorizersApproved.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersApproved.data = data
    },
    TRANSACTION_AUTHORIZERS_DISAPPROVED (state, { totalRecords, data }) {
      state.transactionAuthorizersDisapproved.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersDisapproved.data = data
    },
    TRANSACTION_AUTHORIZERS_DELETED (state, { totalRecords, data }) {
      state.transactionAuthorizersDeleted.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersDeleted.data = data
    },
    TRANSACTION_AUTHORIZERS_AWAITING_DELETION_APPROVAL (state, { totalRecords, data }) {
      state.transactionAuthorizersAwaitingDeletionApproval.totalRecords = parseInt(totalRecords)
      state.transactionAuthorizersAwaitingDeletionApproval.data = data
    },
    FUND_DISBURSEMENT_AUTHORIZERS (state, { isLastAuthorizer, data }) {
      state.fundDisbursementAuthorizers.isLastAuthorizer = isLastAuthorizer
      state.fundDisbursementAuthorizers.data = data
    }
  },

  actions: {
    CreateMerchantTransactionAuthorizerGroup ({ rootState, dispatch }, { headers, data }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post('/MerchantTransactionAuthorizer/CreateMerchantTransactionAuthorizerGroup', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantTransactionAuthorizerGroup ({ rootState, dispatch }, { headers, data }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post('/MerchantTransactionAuthorizer/UpdateMerchantTransactionAuthorizerGroup', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantTransactionAuthorizerGroup ({ rootState, dispatch }, { headers, merchantAuthorizerGroupId }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post(`/MerchantTransactionAuthorizer/DeleteMerchantTransactionAuthorizerGroup?GroupId=${merchantAuthorizerGroupId}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    CreateMerchantTransactionAuthorizerGroupWithAuthorizers ({ rootState, dispatch }, { headers, data }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post('/MerchantTransactionAuthorizer/CreateMerchantTransactionAuthorizerGroupWithAuthorizers', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    CreateMerchantTransactionAuthorizer ({ rootState, dispatch }, { headers, data }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post('/MerchantTransactionAuthorizer/CreateMerchantTransactionAuthorizer', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DeleteMerchantTransactionAuthorizer ({ rootState, dispatch }, { headers, data }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post('/MerchantTransactionAuthorizer/DeleteMerchantTransactionAuthorizer', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    ApproveMerchantTransactionAuthorizer ({ rootState, dispatch }, { headers, merchantTransactionAuthorizerId }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post(`/MerchantTransactionAuthorizer/ApproveMerchantTransactionAuthorizer?MerchantTransactionAuthorizerId=${merchantTransactionAuthorizerId}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    DisapproveMerchantTransactionAuthorizer ({ rootState, dispatch }, { headers, merchantTransactionAuthorizerId, comment }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post(`/MerchantTransactionAuthorizer/DisapproveMerchantTransactionAuthorizer?MerchantTransactionAuthorizerId=${merchantTransactionAuthorizerId}&Comment=${comment}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    ApproveDeleteMerchantTransactionAuthorizer ({ rootState, dispatch }, { headers, merchantTransactionAuthorizerId }) {
      rootState.loading = true

      return new Promise((resolve, reject) => {
        api.post(`/MerchantTransactionAuthorizer/ApproveDeleteMerchantTransactionAuthorizer?MerchantTransactionAuthorizerId=${merchantTransactionAuthorizerId}`, null, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(data => {
            setTimeout(() => {
              rootState.loading = false
              resolve(data)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    // ------------------------------------------------------

    GetMerchantTransactionAuthorizerFlow ({ dispatch, rootState }, config) {
      return new Promise((resolve, reject) => {
        api.get('/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerFlow', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerLevel ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerLevel', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // gets authorizer groups of a merchant
    GetMerchantTransactionAuthorizerGroup ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerGroup', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    // gets authorizer groups that a merchant admin user belongs to
    GetMerchantTransactionAuthorizerGroupByUser ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerGroupByUser', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    // merchant view
    // gets merchant users with fund disbursement privilege
    GetUsersForFundDisbursementAuthorizers ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        api.get('/MerchantTransactionAuthorizer/GetUsersforFundAuthorizers', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizer ({ rootState, dispatch }, { config, merchantAuthorizerGroupId }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizer?MerchantAuthorizerGroupId=${merchantAuthorizerGroupId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerPendingByGroup ({ dispatch, rootState }, { merchantAuthorizerGroupId, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerPendingByGroup?GroupId=${merchantAuthorizerGroupId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerDisapprovedByGroup ({ dispatch, rootState }, { merchantAuthorizerGroupId, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerDisapprovedByGroup?GroupId=${merchantAuthorizerGroupId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerAwaitingDeleteByGroup ({ dispatch, rootState }, { merchantAuthorizerGroupId, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerAwaitingDeleteByGroup?GroupId=${merchantAuthorizerGroupId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerDeletedByGroup ({ dispatch, rootState }, { merchantAuthorizerGroupId, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerDeletedByGroup?GroupId=${merchantAuthorizerGroupId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },

    // admin view
    GetMerchantTransactionAuthorizerPending ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerPending?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&MerchantId=${paginationParams.merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerApproved ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerApproved?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&MerchantId=${paginationParams.merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerDisapproved ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerDisapproved?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&MerchantId=${paginationParams.merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerDeleted ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerDeleted?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&MerchantId=${paginationParams.merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },
    GetMerchantTransactionAuthorizerAwaitingDelete ({ dispatch, rootState }, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetMerchantTransactionAuthorizerAwaitingDelete?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.page}&PageSize=${paginationParams.pageSize}&MerchantId=${paginationParams.merchantId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    },

    GetFundDisbursementAuthorizers ({ dispatch, rootState }, { fundDisbursementParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/MerchantTransactionAuthorizer/GetFunddisbursementAuthorizers?FundDisbusementId=${fundDisbursementParams.fundDisbursementId}&GroupId=${fundDisbursementParams.merchantAuthorizerGroupId}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantTransactionAuthorizer
